// import { FilterItem } from "app/shared/models/filter-group.models";

export class FiltersData {
  categories: ShopFilterItem[];
  genders: ShopFilterItem[];
  sizeGroups: ShopFilterItem[];
  colors: ShopFilterItem;
  // colors: FilterItem[];
  purposes: ShopFilterItem[];
  teams: ShopFilterItem[];
  assortments: FilterCategory;
  seasons: [];

  constructor(s?: Partial<FiltersData>) {
    if (s) {
      Object.assign(<FiltersData>this, s);
    }
  }
}


export class FilterCategory {
  dataSet: ShopFilterItem[];
  dataToView: ShopFilterItem[];
  searchString: string;
  totalCount?: number;
  checked?: boolean;
  constructor(s?: Partial<FilterCategory>) {
    if (s) {
      Object.assign(<FilterCategory>this, s);
    }
  }
}
export class ShopFilterItem {
  name: string;
  id: number;

  constructor(s?: Partial<ShopFilterItem>) {
    if (s) {
      Object.assign(<ShopFilterItem>this, s);
    }
  }
}
